/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmissionEventFull } from './EmissionEventFull';
import {
    EmissionEventFullFromJSON,
    EmissionEventFullFromJSONTyped,
    EmissionEventFullToJSON,
    EmissionEventFullToJSONTyped,
} from './EmissionEventFull';

/**
 * 
 * @export
 * @interface PaginatedEmissionEventFullList
 */
export interface PaginatedEmissionEventFullList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionEventFullList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionEventFullList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionEventFullList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EmissionEventFull>}
     * @memberof PaginatedEmissionEventFullList
     */
    results: Array<EmissionEventFull>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionEventFullList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedEmissionEventFullList interface.
 */
export function instanceOfPaginatedEmissionEventFullList(value: object): value is PaginatedEmissionEventFullList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEmissionEventFullListFromJSON(json: any): PaginatedEmissionEventFullList {
    return PaginatedEmissionEventFullListFromJSONTyped(json, false);
}

export function PaginatedEmissionEventFullListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEmissionEventFullList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EmissionEventFullFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedEmissionEventFullListToJSON(json: any): PaginatedEmissionEventFullList {
    return PaginatedEmissionEventFullListToJSONTyped(json, false);
}

export function PaginatedEmissionEventFullListToJSONTyped(value?: PaginatedEmissionEventFullList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EmissionEventFullToJSON)),
        'num_pages': value['numPages'],
    };
}

